import { Immutable, SB } from '@play-co/replicant';
import { tuple } from '../../utils/types';
import PetSpeciesData from '../../airtable/PetSpecies';

// Detect species type
const species = Array.from(new Set(PetSpeciesData.map(({ id }) => id)));
const speciesTuple = tuple(...species);
type SpeciesType = typeof species[number];

// Detect available stages type
export const stage = Array.from(
  new Set(PetSpeciesData.map(({ stage }) => stage)),
);
type StageType = typeof stage[number];

// Evolution type
type Evolutions = { species: SpeciesType; stage: StageType; timestamp: number };

// Available history records
export type HistoryDeathRecord = {
  type: 'death';
  species: SpeciesType;
  name: string;
  age: number;
  evolutions: Evolutions[];
  timestamp: number;
};

export type HistoryDuoRecord = {
  type: 'duo';
  species: SpeciesType;
  name: string;
  age: number;
  evolutions: Evolutions[];
  friendID: string;
  timestamp: number;
};

export type HistoryFriendDuoRecord = {
  type: 'duoFriend';
  species: SpeciesType;
  name: string;
  age: number;
  friendID: string;
  timestamp: number;
};

export type HistoryRecord = Immutable<
  HistoryDeathRecord | HistoryDuoRecord | HistoryFriendDuoRecord
>;

export const historyFriendDuoRecordMessage = {
  name: SB.string(),
  species: SB.tuple(speciesTuple),
  age: SB.int(),
  friendID: SB.string(),
  timestamp: SB.int(),
};
